import { atom, selectorFamily } from 'recoil';
import { CustomerService } from 'api';
export const getInvoicePagination = atom({
  key: 'getInvoicePagination',
  default: {
    max: 10,
    offset: 0,
    dateFrom: undefined,
    dateTo: undefined
  }
});
export const getInvoices = selectorFamily({
  key: 'getInvoices',
  get: customerId => async ({
    get
  }) => {
    let result = {};
    if (!customerId) return result;
    const pagination = get(getInvoicePagination);
    try {
      result = await CustomerService.getInvoices({
        customerId,
        body: pagination
      });
    } catch (e) {
      console.error(e);
    }
    return result;
  }
});